// removed by extract-text-webpack-plugin
module.exports = {"background":"zS0k1","bold":"_1ePdA"};